import { TranslatedText } from "@/components/common/text";

export const Title = ({ children }) => {
  return (
    <h2 className="text-xl/[31px] text-cm-p-text-primary mt-4 mb-1 font-semibold">
      <TranslatedText>{children}</TranslatedText>
    </h2>
  );
};
